import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        menuActiveId: '0',  //当前路由选中id
        menuActiveName: '',  //当前路由对应菜单名称
        menuActiveParentName: '',  //当前路由对应菜单父级名称
        hasSubMenu: false,    //当前路由对应菜单是否有三级菜单
        subMenuActiveId: '',  //当前子路由选中id
        parentMenuInfo: {}   //当前父路由信息
    },
    mutations: {
        updateMenuActiveId (state, menuActiveId) {
            state.menuActiveId = menuActiveId
        },
        upDateMenuActiveName(state, menuActiveName) {
            state.menuActiveName = menuActiveName
        },
        upDateMenuActiveParentName(state, menuActiveParentName) {
            state.menuActiveParentName = menuActiveParentName
        },
        upDateHasSubMenu(state, hasSubMenu) {
            state.hasSubMenu = hasSubMenu
        },
        updateSubMenuActiveId(state, subMenuActiveId) {
            state.subMenuActiveId = subMenuActiveId
        },
        updateParentMenuInfo(state, parentMenuInfo) {
            state.parentMenuInfo = parentMenuInfo
        },
    },
    plugins: [createPersistedState({
        storage: window.sessionStorage
       })]
})



// WEBPACK FOOTER //
// ./src/store/index.js